import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EmailBelepes from './EmailBelepes';
import GoogleBelepes from './GoogleBelepes';
import NevMegadas from './NevMegadas';
import RendConf from './RendConf';
import { regisztracioCel } from '../../vazlat';

// A belépő ablak (e-mail-cím vagy Google-fiók), amit a vendég a "Regisztrálok" gombra kap.
//  - rendezveny: a választott rendezvény (a címhez és a levélben kapott gombhoz); nélküle csak belépés
//  - cel: ha meg van adva, ide lép a felhasználó belépés után (pl. a védett oldal, ahonnan átirányítottuk)
//  - Google: belépés után az ablak bezárul, és a felhasználó rögtön a cél oldalra lép (ha nincs neve, előbb a név bekérése)
//  - e-mail: a levél gombjával folytatható; az ablak ezt közli, és bezárható
export default function BelepesModal({show, rendezveny, cel, onHide, onGoogleCredential, onSetNev, callAPI, getCommInProgress}) {
    const navigate = useNavigate();
    const [emailElkuldve, setEmailElkuldve] = useState(false);
    const [nevetKerunk, setNevetKerunk] = useState(false);

    function tovabb(felhasznalo){
        const utvonal = cel || (rendezveny ? regisztracioCel(felhasznalo, rendezveny.Id) : null);
        onHide();
        if (utvonal !== null){
            navigate(utvonal);
        }
    }

    function onCredential(credential){
        onGoogleCredential(credential, function(felhasznalo){
            if (felhasznalo.Nev === ''){
                setNevetKerunk(true);
            }else{
                tovabb(felhasznalo);
            }
        });
    }

    function onSave_nev(nev){
        onSetNev(nev, tovabb);
    }

    function onExited(){
        setEmailElkuldve(false);
        setNevetKerunk(false);
    }

    return (
        <Modal show={show} onHide={onHide} onExited={onExited} centered className="belepesModal">
            <Modal.Body>
                <button type="button" className="btn-close belepesBezar" aria-label="Bezárás" onClick={onHide} />
                <div className="belepesKartya modalban">
                    {nevetKerunk ?
                        <NevMegadas
                            callAPI={callAPI}
                            getCommInProgress={getCommInProgress}
                            nev=""
                            onSave={onSave_nev}
                        />
                        :
                        <>
                            <h2 className="cim">{rendezveny ? 'Regisztráció' : 'Belépés'}</h2>
                            {rendezveny ?
                                <div className="alcim">{rendezveny.Cim}{rendezveny.Kezdes ? ' - ' + rendezveny.Kezdes : ''}</div>
                                : undefined
                            }
                            <div className="vonal" />

                            <EmailBelepes
                                onComplete={function(sikeres){ if (sikeres) { setEmailElkuldve(true); } }}
                                onBezar={onHide}
                                rendezvenyID={rendezveny ? rendezveny.Id : undefined}
                                callAPI={callAPI}
                                getCommInProgress={getCommInProgress} />

                            {!emailElkuldve ?
                                <div>
                                    <div className="vagy"><span>vagy</span></div>
                                    <GoogleBelepes onCredential={onCredential} />
                                </div>
                                : undefined
                            }

                            {RendConf.contact_email ?
                                <div className="kapcsolat">
                                    Ha kérdése van: <FontAwesomeIcon icon="fa-envelope" /> <a href={'mailto:' + RendConf.contact_email}>{RendConf.contact_email}</a>
                                </div>
                                : undefined
                            }
                        </>
                    }
                </div>
            </Modal.Body>
        </Modal>
    );
}
